export default function () {
    const currentYear = new Date().getFullYear();
    return (
        <div className="mx-auto container w-full px-4 pb-4 md:py-6 lg:py-8">
            <hr className="my-6 border-gray-200 dark:border-gray-700 sm:mx-auto lg:my-8"/>
            <div className="sm:flex sm:items-center sm:justify-between">
                    <span className="text-sm text-gray-500 dark:text-gray-400 sm:text-center">© {currentYear} <a
                        href={route('home')} className="hover:underline">Subtitle Extractor</a>. All Rights Reserved.
                </span>
                <div className="flex mt-4 sm:justify-center sm:mt-0">
                    <a href={route('pricing')} className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                        Pricing
                    </a>
                    <a
                        href="https://chromewebstore.google.com/detail/subtitle-extractor/mifpkhfchoibfhkcpiecalegnngapioj"
                        target="_blank"
                        className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 ms-5"
                    >
                        Chrome Extension
                    </a>
                    <a target="_blank" href="/blog" className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 ms-5">
                        Blog
                    </a>
                    <a href={route('privacy')} className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 ms-5">
                        Privacy
                    </a>
                </div>
            </div>

        </div>
    )
}
